import { render, staticRenderFns } from "./AgreementListRecord.vue?vue&type=template&id=485aa9ce&scoped=true&"
import script from "./AgreementListRecord.vue?vue&type=script&lang=js&"
export * from "./AgreementListRecord.vue?vue&type=script&lang=js&"
import style0 from "./AgreementListRecord.vue?vue&type=style&index=0&id=485aa9ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485aa9ce",
  null
  
)

export default component.exports